import { create } from "zustand";
import { ServiceType } from "~/utils/constants";

// Enum for sorting options
export enum SortBy {
  DATE = 'date',
  VESSEL = 'vessel',
  WEEK = 'week',
}

type TVesselLoadListFilters = {
  vesselId?: string;
  page: number;
  serviceType: ServiceType;
  pageSize: number;
  sortBy: SortBy; // Added sorting parameter
  startDate?: string;
  endDate?: string;
};

type State = {
  formState: {
    open: boolean;
    vesselId?: string;
  };
  filters: TVesselLoadListFilters;
};

type Actions = {
  setFilters: (filters: Partial<TVesselLoadListFilters>) => void;
  resetFilters: () => void;
  setFormState: (formState: Partial<State["formState"]>) => void;
  resetFormState: () => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  setSortBy: (sortBy: SortBy) => void; // Added sort action
};

const initialState: TVesselLoadListFilters = {
  vesselId: undefined,
  page: 1,
  pageSize: 10,
  sortBy: SortBy.DATE, // Default sort by date
  serviceType: ServiceType.DELIVERY, // Load lists are specifically for delivery services
  startDate: undefined,
  endDate: undefined,
};

const initialFormState: State["formState"] = {
  open: false,
  vesselId: undefined,
};

export const useVesselLoadListStore = create<State & Actions>()((set) => ({
  formState: initialFormState,
  filters: initialState,
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  setFormState: (formState) =>
    set((state) => ({
      formState: {
        ...state.formState,
        ...formState,
      },
    })),
  resetFormState: () => set({ formState: initialFormState }),
  setPage: (page) =>
    set((state) => ({
      filters: {
        ...state.filters,
        page,
      },
    })),
  setPageSize: (pageSize) =>
    set((state) => ({
      filters: {
        ...state.filters,
        pageSize,
      },
    })),
  setSortBy: (sortBy) => 
    set((state) => ({
      filters: {
        ...state.filters,
        sortBy,
      },
    })),
}));
